import { useEffect, useState } from 'react'

export const useDarkMode = (monday: any): boolean => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false)

  useEffect(() => {
    monday.listen('context', (res: any) => {
      if (res.data.theme === 'dark' || res.data.theme === 'night' || res.data.theme === 'hacker_theme' || res.data.theme === 'black') setIsDarkMode(true)
      else setIsDarkMode(false)
    }) 
  }, [monday])

  return isDarkMode
}
